import type { ReactNode } from "react";
import { useFormikContext } from "formik";
// @ts-expect-error pure js
import TabbedForm from "../UI/TabbedForm";
// @ts-expect-error pure js
import Tabs from "../UI/Tabs";
import styles from "./AuthFormSignup.module.css";
import { UserTypeButtons, MotivationField } from "./SignupBailleurFields";

function AutoAdvanceUserType() {
  const { selectTab } = Tabs.useActiveTab();
  return (
    <UserTypeButtons
      onSelect={(home) =>
        selectTab(home === "/bailleur" ? "attentes" : "informations", true)
      }
    />
  );
}

function AutoAdvanceMotivation() {
  const { selectTab } = Tabs.useActiveTab();
  return <MotivationField onSelect={() => selectTab("informations")} />;
}

function ActionsExceptFirstTab({ error }: { error: string }) {
  const { isFirstTab, activeTab } = Tabs.useActiveTab();
  const {
    values: { motivation },
  } = useFormikContext<{ motivation: string }>();
  if (isFirstTab) return null;
  const motivationMissing = activeTab === "attentes" && !motivation;
  return (
    <TabbedForm.Actions
      error={error}
      disableNext={motivationMissing}
      disableNextReason="Sélectionnez une réponse pour continuer"
    />
  );
}

interface SignupStepsProps {
  id: string;
  error: string;
  children: ReactNode;
}

export default function SignupSteps({ id, error, children }: SignupStepsProps) {
  const {
    values: { home },
  } = useFormikContext<{ home: string }>();

  return (
    <TabbedForm id={id}>
      <TabbedForm.TabList className={styles.tabList}>
        <TabbedForm.Tab panelId="profil" index={0}>
          Profil
        </TabbedForm.Tab>
        {home === "/bailleur" && (
          <TabbedForm.Tab panelId="attentes" index={1}>
            Vos attentes
          </TabbedForm.Tab>
        )}
        <TabbedForm.Tab panelId="informations" index={2}>
          Vos informations
        </TabbedForm.Tab>
      </TabbedForm.TabList>

      <TabbedForm.TabPanel id="profil">
        <AutoAdvanceUserType />
      </TabbedForm.TabPanel>

      {home === "/bailleur" && (
        <TabbedForm.TabPanel id="attentes">
          <AutoAdvanceMotivation />
        </TabbedForm.TabPanel>
      )}

      <TabbedForm.TabPanel id="informations">
        <div className={styles.inputs}>{children}</div>
      </TabbedForm.TabPanel>

      <ActionsExceptFirstTab error={error} />
    </TabbedForm>
  );
}
